import { history, store } from '../App'
import config from '../config'

export function verifyEmail (value) {
  const emailRex = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (emailRex.test(value)) {
    return true
  }
  return false
}

export function verifyPassword (value) {
  const passwordRex = /^[\S]{5,14}$/
  if (passwordRex.test(value)) {
    return true
  }
  return false
}

export function verifyLength (value, length) {
  if (value && ((value + '').length >= length)) {
    return true
  }
  return false
}

export function verifyMobileNumber(value) {
  const mobRex = /^[0-9]{10}$/
  if (mobRex.test(value)) {
    return true
  }
  return false
}

export function isNumber (value) {
  const numRex = /^[0-9\b]+$/
  return !!numRex.test(value)
}

export async function unAuthorized () {
  localStorage.removeItem('Token')
  store.dispatch({
    type: 'TOKEN_LOGIN',
    payload: {
      token: null
    }
  })
  history.push('/auth')
}

export function getUrl (bucketUrl) {
  if (bucketUrl === 'kyc') return config.KYC_URL
  return config.MEDIA_BUCKET_URL
}

export function verifyUrl (value) {
  const urlRex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
  if (urlRex.test(value)) {
    return true
  }
  return false
}

export function alertClass (status, close) {
  if (status) {
    return `sucess-alert ${!close ? 'alert' : 'alert-close'}`
  }
  return `fail-alert ${!close ? 'alert' : 'alert-close'}`
}

export function modalMessageFunc (modalMessage, setModalMessage, setClose) {
  if (modalMessage) {
    setTimeout(() => {
      setModalMessage(false)
      setClose(false)
    }, 3000)
    setTimeout(() => {
      setClose(true)
    }, 2500)
  }
}
